// Feature flags for DSS application
// Minimal feature flag system for controlling plugin availability

const featureFlags = {
  // IVR Management Plugin - Enabled in all environments including production
  IVR_PLUGIN: process.env.NODE_ENV === 'development' || process.env.VUE_APP_BUILD_MODE === 'test-local' || process.env.VUE_APP_BUILD_MODE === 'test' || process.env.NODE_ENV === 'production'
};

export default {
  isEnabled(flagName) {
    return featureFlags[flagName] === true;
  },
  
  getAll() {
    return { ...featureFlags };
  }
};
